var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconrss = function SvgIconrss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.337C16 .598 15.402 0 14.663 0H1.337C.598 0 0 .598 0 1.337v13.326C0 15.402.598 16 1.337 16h13.326c.739 0 1.337-.598 1.337-1.337V1.337zM4.486 13.4a1.486 1.486 0 110-2.971 1.486 1.486 0 010 2.971zm8.914 0C13.4 7.666 8.735 3 3 3v1.98c4.643 0 8.42 3.778 8.42 8.42h1.98zM3 6.466A6.941 6.941 0 019.933 13.4h-1.98A4.958 4.958 0 003 8.448V6.466z",
    fill: "#A7A7A7"
  })));
};
export default SvgIconrss;